import { ContractError } from './errors';

const statusOf = (error: unknown): number | null => {
  const status = (error as { status?: unknown } | null | undefined)?.status;
  return typeof status === 'number' ? status : null;
};

const isClientError = (status: number | null): boolean => status !== null && status >= 400 && status < 500;

export const shouldRetry = (failureCount: number, error: unknown): boolean => {
  if (error instanceof ContractError) return false;
  if (isClientError(statusOf(error))) return false;
  return failureCount < 2;
};

export const isAmbiguousFailure = (error: unknown): boolean => error instanceof ContractError || !isClientError(statusOf(error));
